import EnumObject from '@/domain/enum-object.entity';
import Rule from '@/domain/rule/entity/rule.entity';
import ContractItemExchangeCurrency from './contract-item-exchange-currency.entity';
import ContractItemExchange from './contract-item-exchange.entity';
import ContractRule from './contract-rule.entity';

export default class ContractItemRule {
  id: string;

  number: number;

  description: string;

  observation: string;

  frequency: EnumObject;

  dueDay: number;

  billingStartCompetence: string;

  rules: ContractRule[] = [];

  hasExchangeConfiguration: boolean;

  exchange?: ContractItemExchange;

  ruleGroupId: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.number = obj.number || 0;
    this.description = obj.description || '';
    this.observation = obj.observation || '';
    this.frequency = EnumObject.of(obj.frequency);
    this.dueDay = obj.dueDay || 0;
    this.billingStartCompetence = obj.billingStartCompetence || '';
    if (obj.rules) {
      this.rules = ContractRule.ofList(obj.rules);
    }
    this.hasExchangeConfiguration = obj.hasExchangeConfiguration || false;
    if (obj.exchange) {
      this.exchange = ContractItemExchange.of(obj.exchange)
    }
    this.ruleGroupId = obj.ruleGroupId || '';
    this.verifyRuleLength();
  }

  public static of(obj: any = {}): ContractItemRule {
    return new ContractItemRule(obj || {});
  }

  public static ofList(obj: any[]): ContractItemRule[] {
    return obj.map(this.of);
  }

  verifyRuleLength() {
    if (this.rules.length === 0) {
      this.rules.push(ContractRule.of({}));
    }
  }

  updateRules(contractRule: Rule, index: number) {
    this.rules.splice(index, 1, ContractRule.of(contractRule));
  }

  clearRule(index: number) {
    this.rules.splice(index, 1, ContractRule.of({}));
  }

  addNewRule() {
    this.rules.push(ContractRule.of({}));
  }

  get convertTo() {
    return this.exchange?.convertTo || ContractItemExchangeCurrency.of({})
  }

  get convertFrom() {
    return this.exchange?.convertFrom || ContractItemExchangeCurrency.of({})
  }
}
